import { getLink } from '../../../utils/utils';

import author from './author';

const cite1Text = (
  `Ĉiuj propraj nomoj kaj datoj, kaj ĝenerale la tuta teksto en la originalo ekzistas en formo de onda emisio. 
	Niaj tradukaparatoj kapablas traduki la tekston; sed prezenti per sonoj la ondajn nociojn, kiuj ne havas konformon en nia lingvo, ne eblas. 
	Tial ni, por ne produkti entojn senbezone, ne montras ĉi tie arbitrajn literumaĵojn, sed simple lasas lakunojn.`
)
const cite1 = (
  `<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">[1]</a></acronym></sup>`
)

const cite2Text = (
  `Разумеется, наблюдатель не мог знать, что земная эволюция просто вернулась к тому, что было испробовано во многих таксонах на ранних стадиях жизни на Земле. 
  В природе ничего не пропадает напрасно; и вот приспособление древних беспозвоночных вновь возникло на высшей пока что точке развития жизни: у Нomo ĉu Sapiens.`
)
const cite2 = (
  `<sup><acronym title="${cite2Text}"><a href="#cite_note2" id="cite_ref2">[2]</a></acronym></sup>`
)

const content = {
  esp: (
    `
			<div style="text-align: justify;">
				<p class="mb-3">
					Mi, ()${cite1}, piloto de la ŝipo () de la Kosma Kontrolo, vizitis la planedon 3862 enkadre de plenumo de la ĝenerala tasko pri inspektado de marĝenaj loĝataj mondoj.
				</p>
				
				<p class="mb-3">
					La antaŭa vizito okazis en () far piloto () en la ŝipo (). 
					Sur la planedo dum tiu tempo pasis, laŭ propra tempokalkulo, proksimume 2600 rotacioj ĉirkaŭ ĝia centra astro, 
					t.e. la tempodaŭro indikita laŭ la Statuto de Kosma Kontrolo por regulaj kontrolvizitoj. 
					Tial, konforme al la Statuto, mi elektis tiun ĉi planedon kiel la vica punkto de mia observado kaj okazigis la surgrundigon en la loko indikita en la Astra Atlaso (vidu Apendicon 1). 
				</p>
				
				<p class="mb-3">
					La esploro montris, ke la planedo troviĝas sur proksimume atendata nivelo de evoluo: modera industriigo, foresto de kosmaj flugoj, 
					foresto de ekuzo de grunda kaj oceana sino; do, la nivelo ne sufiĉa por aliĝo al Tutkosma Unio. 
					</p>
				
				<p class="mb-3">
					Konkrete: (ĉi tie sekvas speciala informo, apenaŭ interesa por niaj legantoj. Por detaloj vidu Apendicon 3). 
				</p>
				
				<p class="mb-3">
					Sed enkadre de natura evoluo estis farita tia paŝo, kiu, laŭ mia scio, ne estis observita sur aliaj mondoj de nia Sistemo. 
					Temas pri multobligo de t.n. «racihavaj» loĝantoj. 
					Sur tiu ĉi planedo troviĝas sufiĉe multfaceta organika vivo; multaj ĝiaj reprezentantoj posedas, 
					laŭ niaj kriterioj, relative altan intelekton. 
					Tamen, ili ne kreis maŝinan civilizacion, sed preferis fermitan disvolviĝon nur ene de sia propra biologia taksono 
					(la listo de taksonoj aldonatas, vidu Apendicon 4). 
					Tio ebligis al ili konservi sian specifan loĝareon kaj garantii pluvivon sen drastaj konfliktoj kun apudaj taksonoj. 
					Estis efektivigataj kontaktoj kun (la listo aldonatas, vidu Apendicon 5); 
					ili sendube estas racihavaj, sed fermitaj en sia cirklo kaj kategorie evitas kontaktojn kun aliaj mondoj. 
					Mi proponas speciale reveni al ili post ioma tempo, aldoninte por tio necesajn ŝanĝojn en la planon de kontrolvizitoj. 
				</p>
				
				<p class="mb-3">
					En la nuna tempo dominas surplanede unusola taksono, kiu kreis maŝinan civilizacion. 
					Ĉar la daŭro de ekzisto de tiu civilizacio fakte estas nekomparebla kun la tuta daŭro de organika vivo sur la planedo, 
					do eblas, ke la videbla dominado estas simple la sekvo de ĝia relativa juneco, 
					kaj kun la paso de tempo ĝi ellaboros pli harmoniajn kunlaborajn rilatojn kun siaj najbaroj surplanede.
				</p>
				
				<p class="mb-3">
					Same kiel sur plejmulto de marĝenaj planedoj, la maŝina civilizacio kaj relativa inteligenteco gvidis la dominantan taksonon al t.n. proliferado, aŭ nekontrolebla multobliĝo. 
					Aperis minaco de elpremo aŭ eĉ ekstermo de cetera organika loĝantaro de la planedo pro neeviteblaj internaj konfliktoj. 
					Sed ĉi tie la evoluo faris neordinaran${cite2} paŝon: ĝi momente duonigis la kvanton de individuoj.
					Okazis tio sprite kaj originale: la masklaj individuoj ekzistas nun nur kiel parazitoj en la korpoj de inoj. 
					La priskribo de tia ŝanĝo troviĝas en la Apendico 6, kvankam la detaloj ĝis nun ne klaras al flanka observanto. 
				</p>
				
				<p class="mb-3">
					Tiu okazo, radikale ŝanĝinta la evoluon de «racihava» taksono sur la planedo 3862, okazis, laŭ nia opinio, tute antaŭnelonge, 
					ĉar konserviĝis la spuroj de sufiĉe pli alta maŝina civilizacio kaj de naturocido. 
					Eble, la ekzisto de nur unu evidenta sekso estas nova paŝo en evoluo de organika vivo. 
					Sed eble, tio estas signo de ĝia degenero. 
					Ajnaokaze, la observado de la planedo 3862 devas esti daŭrigata. 
				</p>


				<p class="mb-5" style="display: flex; justify-content: space-between;">
					<span>Dato: ()</span>
					<span>Piloto: ()</span>
				</p>
				
				<p>Apendicoj:</p>
				<ol>
					<li>Paĝo de la Astra Atlaso kun preciza indiko de la situo de la planedo 3862</li>
					<li>Loglibro de la kosmoŝipo ()</li>
					<li>Rezultoj de la kemia esplorado de solida, likva kaj gasforma substanco de la planedo 3862</li>
					<li>Listo de ĉefaj taksonoj de organika vivo de la planedo 3862</li>
					<li>Priskribo de kontaktoj kun plej “racihavaj” loĝantoj de la  planedo 3862</li>
					<li>Speciala resumo pri “vira parazitismo” (por limigita uzo)</li>
				</ol>
			</div>
    `
  )
}

const itemName = {
  esp: 'El raporto de piloto el Kosma Kontrolo'
}

const itemDate = {
  rus: 'Decembro 2022'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
		itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 